export const STUDIO_SECTION_DESCRIPTIONS = {
  inspiration: 'Videos and images that inspire your coloring',
  media: 'Your inventory of pencil sets and other coloring media',
  combos: 'Save you favoritecolor combinations from your pencils',
  palettes: 'Create color palettes to plan your next piece',
  books: 'Organize your coloring books and the pages you are working on',
};
